var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1424_15036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.40234 45.4139L5.73111 31.4121L15.6354 41.3312L1.40234 45.4139Z",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4934 5.60878L5.73828 31.4023L15.6441 41.3229L41.3992 15.5294L31.4934 5.60878Z",
    fill: "#E6E6E6",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3664 6.60762L40.4019 2.63717C39.6139 1.84897 38.5457 1.40625 37.432 1.40625C36.3183 1.40625 35.2501 1.84897 34.4621 2.63717L31.4922 5.6115L41.3965 15.5306L44.3664 12.6264C44.7667 12.2344 45.0847 11.7663 45.3019 11.2495C45.519 10.7327 45.6309 10.1777 45.6309 9.61702C45.6309 9.05634 45.519 8.50131 45.3019 7.98452C45.0847 7.46774 44.7667 6.99961 44.3664 6.60762Z",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47266 45.5957H46.3013",
    stroke: "#858585",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1424_15036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1da35a64aaa21106d6fe72d5835fdd7f.svg";
export { ForwardRef as ReactComponent };